
export function friendlyBrowser(chUa?: string | null, legacyUa?: string | null): string {
  if (!chUa && !legacyUa) return 'Unknown';

  const matches = chUa?.match(/"([^"]+)";v="([\d.]+)"/g) ?? [];
  const parsed = matches.map(s => {
    const m = /"([^"]+)";v="([\d.]+)"/.exec(s)!;
    const brandRaw = m[1];
    const ver = m[2].split('.')[0]; // major
    return { brandRaw, brand: brandRaw.replace(/^Microsoft /, ''), ver };
  });

  // GREASE filter: Not A Brand variants like Not)A;Brand / Not=A?Brand, etc.
  const isGrease = (b: string) => /^not.*brand$/i.test(b.replace(/[^a-z]/gi, ''));
  const filtered = parsed.filter(p => !isGrease(p.brandRaw));

  // Prefer a non-Chromium brand; else fall back to Chromium; else legacy UA
  const pick = filtered.find(p => !/Chromium/i.test(p.brandRaw))
    ?? filtered.find(p => /Chromium/i.test(p.brandRaw));

  if (pick) return `${pick.brand} ${pick.ver}`;

  // Legacy fallback (Safari has no CH)
  if (legacyUa) {
    const mEdge = /Edg\/(\d+)/i.exec(legacyUa); if (mEdge) return `Edge ${mEdge[1]}`;
    const mChrome = /Chrome\/(\d+)/i.exec(legacyUa); if (mChrome) return `Chrome ${mChrome[1]}`;
    const mFx = /Firefox\/(\d+)/i.exec(legacyUa); if (mFx) return `Firefox ${mFx[1]}`;
    const isSafari = /Safari\//i.test(legacyUa) && !/Chrome/i.test(legacyUa);
    if (isSafari) {
      const m = /Version\/(\d+)/i.exec(legacyUa);
      return `Safari ${m ? m[1] : ''}`.trim();
    }
  }
  return 'Unknown';
}




export function parseUaBrands(chUa?: string | null): { brand: string; ver: string; major: string }[] {
  if (!chUa) return [];
  const items = chUa.match(/"([^"]+)";v="([\d.]+)"/g) ?? [];
  return items.map(s => {
    const m = /"([^"]+)";v="([\d.]+)"/.exec(s)!;
    const ver = m[2];
    return { brand: m[1], ver, major: ver.split('.')[0] };
  });
}

export function friendlyOs(platform?: string | null, version?: string | null): string {
  const p = (platform ?? '').replace(/"/g, '').trim();
  const v = (version ?? '').replace(/"/g, '').trim();
  if (!p && !v) return 'Unknown';
  if (!p) return v || 'Unknown';
  const major = v.split('.')[0] || v;
  return v ? `${p} ${major}` : p;
}


export function deviceLabel(chMobile?: boolean | null): string {
  return chMobile === true ? 'Mobile' : chMobile === false ? 'Desktop' : 'Unknown';
}

export function uaTooltipText(row: {
  chUaFullVersion?: string | null;
  userAgent?: string | null;
  chPlatform?: string | null;
  chPlatformVersion?: string | null;
  chMobile?: boolean | null;
  ipAddress?: string | null;
}): string {
  const lines: string[] = [];
  if (row.chUaFullVersion) lines.push(`Full Versions: ${row.chUaFullVersion}`);
  if (row.chPlatform || row.chPlatformVersion) lines.push(`OS: ${friendlyOs(row.chPlatform, row.chPlatformVersion)}`);
  lines.push(`Device: ${deviceLabel(row.chMobile)}`);
  if (row.ipAddress) lines.push(`IP: ${row.ipAddress}`);
  if (row.userAgent) {
    const ua = row.userAgent.length > 180 ? row.userAgent.slice(0, 180) + '…' : row.userAgent;
    lines.push(`UA: ${ua}`);
  }
  return lines.join('\n');
}

export function browserIconClass(browserName: string): string {
  const b = browserName.toLowerCase();
  if (b.includes('edge')) return 'fa-brands fa-edge';
  if (b.includes('chrome')) return 'fa-brands fa-chrome';
  if (b.includes('firefox')) return 'fa-brands fa-firefox-browser';
  if (b.includes('safari')) return 'fa-brands fa-safari';
  if (b.includes('opera')) return 'fa-brands fa-opera';
  return 'fa-duotone fa-globe'; // nicer globe from duotone
}

export function osIconClass(platform?: string | null): string {
  const p = (platform ?? '').toLowerCase().replace(/"/g, '');
  if (p.includes('windows')) return 'fa-brands fa-windows';
  if (p.includes('mac') || p.includes('ios')) return 'fa-brands fa-apple';
  if (p.includes('android')) return 'fa-brands fa-android';
  if (p.includes('linux')) return 'fa-brands fa-linux';
  return 'fa-duotone fa-computer'; // duotone fallback
}

export function deviceIconClass(chMobile?: boolean | null): string {
  if (chMobile === true) return 'fa-duotone fa-mobile-screen-button';
  if (chMobile === false) return 'fa-duotone fa-desktop';
  return 'fa-duotone fa-display'; // unknown
}
